export const useCheckoutAnalyticsStore = defineStore('checkoutAnalytics', () => {
    const trackedAncillaries: Ref<OfferAncillary[]> = ref([]);

    function reset() {
        trackedAncillaries.value = [];
    }

    return {
        trackedAncillaries,
        reset,
    };
}, {
    persist: {
        ...storePersist.storePersistOptions,
        key: 'checkout-analytics-v6',
    },
});
